import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { IEnquiryFlight } from '@simplyfly/shared';
import { IEnquiry } from '@simplyfly/shared';
import { EnquiryFlightService } from 'src/app/services/enquiry-flights/enquiry-flights.service';
import { FlightChecklistService } from 'src/app/services/flight-checklists/flight-checklists.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

enum EnumAddType {
  scratch = 'scratch',
  duplicate = 'duplicate'
}

@Component({
    selector: 'app-enquiry-flight-add',
    templateUrl: './enquiry-flight-add.component.html',
    styleUrls: ['./enquiry-flight-add.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, DatePipe, TranslateModule]
})
export class EnquiryFlightAddComponent {
  @Input() enquiry: IEnquiry | null = null;
  @Input() enquiryFlights: IEnquiryFlight[] = [];
  @Input() inModal = false;

  @Output() editEnquiryFlight: EventEmitter<IEnquiryFlight | null> = new EventEmitter();

  @ViewChild('btnCloseModal') btnCloseModalEl: ElementRef;

  EnumAddType = EnumAddType;

  addType: EnumAddType = EnumAddType.scratch;
  enquiryFlightId: string | null = null;

  constructor(
    private loaderService: LoaderService,
    private enquiryFlightService: EnquiryFlightService,
    private flightChecklistService: FlightChecklistService
  ) {}

  async save(): Promise<void> {
    let newEnquiryFlight: IEnquiryFlight | null = null;

    if (this.addType === EnumAddType.duplicate) {
      this.loaderService.presentLoader('Copie des informations du leg sélectionné ...');

      for (const enquiryFlight of this.enquiryFlights) {
        if (enquiryFlight.id === this.enquiryFlightId) {
          newEnquiryFlight = await this.enquiryFlightService.duplicateEnquiryFlight(enquiryFlight);

          await this.flightChecklistService.duplicateForEnquiryFlight(
            enquiryFlight.id,
            newEnquiryFlight.id
          );

          break;
        }
      }

      await this.loaderService.hideLoaderOnSuccess();
    }

    if (this.btnCloseModalEl) {
      this.btnCloseModalEl.nativeElement.click();
    }

    this.editEnquiryFlight.emit(newEnquiryFlight);
  }
}
